
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2140|7627)8$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
